import { CategorySpecialtyResponse } from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/category';

export class CategoryApi {
    public static async getCategorySpecialities(): Promise<CategorySpecialtyResponse> {
        const res = await axios.get<CategorySpecialtyResponse>(`${BASE_URL}/specialty`);

        return res.data;
    }
}

export { BASE_URL as CATEGORY_BASE_URL };
